import { supabase } from './supabase';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL!;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY!;

/**
 * Closes the signed-in member account: anonymizes `public.users`, then removes Auth user.
 * Requires Edge Function `delete-member-account` and DB columns per PRD; optional `alreadyDeleted` in body = success.
 */
export async function deleteMemberAccount(): Promise<{ error: string | null }> {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (!session?.access_token) {
    return { error: 'You are not signed in.' };
  }

  const url = `${SUPABASE_URL.replace(/\/$/, '')}/functions/v1/delete-member-account`;
  let res: Response;
  try {
    res = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${session.access_token}`,
        apikey: SUPABASE_ANON_KEY,
        'Content-Type': 'application/json',
      },
    });
  } catch (e: unknown) {
    const message = e instanceof Error ? e.message : 'Network error';
    return { error: message };
  }

  let body: { error?: string; ok?: boolean; alreadyDeleted?: boolean } = {};
  try {
    body = (await res.json()) as { error?: string; ok?: boolean };
  } catch {
    /* ignore */
  }

  if (!res.ok) {
    return { error: body.error || `Request failed (${res.status})` };
  }

  if (!body.ok) {
    return { error: body.error || 'Account deletion failed.' };
  }

  return { error: null };
}
